import * as Yup from 'yup';
import { User } from 'store/modules/api/sgu/loginUnico/types';
import { IncluirRequest } from 'store/modules/api/sguService/estatisticasIncluir/types';
import { ICaracteristicaVeiculo } from 'store/modules/api/detranCrv/SolicitarDocumentos/ConsultarVeiculoV110/types';

export interface IAlteracaoModificacao {
	tipoPesquisa: 'Chassi' | 'Placa';
	chassi: string;
	placa: string;
	categoria?: string | number;
}

export const initialValues: IAlteracaoModificacao = {
	tipoPesquisa: 'Chassi',
	chassi: '',
	placa: '',
	categoria: '',
};

export const schema = Yup.object<IAlteracaoModificacao>().shape({
	chassi: Yup.string().when('tipoPesquisa', {
		is: tipoPesquisa => tipoPesquisa === 'Chassi',
		then: Yup.string()
			.required('Campo Obrigatório: Documento / Chassi.')
			.max(22, 'Campo Chassi: Tamanho máximo de 22 caracteres.'),
	}),
	categoria: Yup.string().required(`Campo Obrigatório: Categoria.`),
	placa: Yup.string().when('tipoPesquisa', {
		is: tipoPesquisa => tipoPesquisa === 'Placa',
		then: Yup.string()
			.required('Campo Obrigatório: Documento / Placa.')
			.max(22, 'Campo Placa: Tamanho máximo de 22 caracteres.'),
	}),
});

export const treatRequestSguStatistics = (
	data: ICaracteristicaVeiculo,
	user: User,
	formData: IAlteracaoModificacao,
): IncluirRequest => {
	const payload: IncluirRequest = {
		observacao: `Chassi: ${
			data.caracteristicaVeiculo.chassi || formData.chassi || 'N/A'
		}, Tipo de Processo: ${'N/A'}, Renavam Gerada ${
			data.caracteristicaVeiculo.renavam
		}`,
		descricaoSistemaOrigem: 'BALCÃO ÚNICO 4.0',
		tipoDocumento: 'CPF',
		numeroDocumento: 'N/A',
		codigoLocalidade: (user?.posto && Number(user.posto)) || 0,
		idOrgao: 5,
		cpf: user.cpf,
		descricaoServico: 'Alteração de dados cadastrais',
		idMotivo: 16,
	};

	return payload;
};
